// SPEC_DEMO.md PR-5 → Out-of-scope row "Mobile demo experience".
// Shown when viewport width is below 900px. The marketing site should
// also handle this with a `<picture>` fallback above the iframe, but
// this is the bundle's own safety net.

import React from 'react';

export default function MobileGate() {
  return (
    <div className="demo-mobile-gate">
      <div className="demo-mobile-gate-card">
        <h1>View on desktop</h1>
        <p>
          The SEIDR site-finder demo needs more screen than a phone gives.
          Open this page on a laptop or desktop to explore.
        </p>
        <a
          className="demo-mobile-gate-cta"
          href="https://calendly.com/benjamin-respire/seidr"
          target="_top"
          rel="noopener noreferrer"
        >
          Book a demo →
        </a>
      </div>
    </div>
  );
}
